module.exports = __webpack_public_path__ + "static/images/power-list1.7aa308d.png";